import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=f34544ce&scoped=true&"
import script from "./SupportButton.vue?vue&type=script&lang=js&"
export * from "./SupportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34544ce",
  null
  
)

export default component.exports